<template>
  <div id="faq">
    <section>
      <div class="py-12"></div>
      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">
          FREQUENTLY ASKED QUESTIONS
        </h2>

        <v-responsive class="mx-auto mb-8" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-responsive
          class="mx-auto title font-weight-light mb-8"
          max-width="720"
        >
          <VueFaqAccordion :items="questions" activeColor="#EF45AA" />
        </v-responsive>
      </v-container>
    </section>
  </div>
</template>

<script>
import VueFaqAccordion from "vue-faq-accordion";

export default {
  name: "FAQ",

  components: {
    VueFaqAccordion,
  },

  data() {
    return {
      questions: [
        {
          title: "How do I post a bun?",
          value:
            "To post a bun first click on the camera icon in the upper left corner of the 'Feed' tab. From here you can take a photo using the built-in viewfinder, or select up to 3 images and/or videos using the gallery image in the lower left of the viewfinder. Once you have selected your image(s) tab on 'continue' to take you to the 'New Post' screen. From here you may add a caption, add a location, and determine the visibility of the post. Once you are satisifed with your post, click 'Share' in the upper right corner. The post will be uploaded and you will be brought back to the 'Feed' tab upon completion.",
          category: "Using Bun Alert",
        },
        {
          title: "What is the difference between Feed vs Global?",
          value:
            "When posting a bun you can select a visibility level of 'Global', 'Friends', and 'Only Me'. Posts shown in the 'Feed' will appear from anyone you are currently following and posts you upload. Posts shown in the 'Global' tab will appear from any posts with the 'Global' visibility tag.",
          category: "Using Bun Alert",
        },
        {
          title: "Changing your username",
          value:
            "Usernames must be 3 to 16 characters and can only contain alphanumeric characters and may include '-' and '_'",
          category: "User",
        },
        {
          title: "What is my location used for?",
          value:
            "When posting a bun, you may opt to tag the post with a geolocation. The location permission is needed to suggest nearby locations and to enable search for 'places'. We will only use these coordinates if the user allows permission and specifies a location. This information is used on the Map View to show nearby buns.",
          category: "Location",
        },
      ],
    };
  },
};
</script>